import { queryOptions } from '@tanstack/react-query';
import { getStatistics } from '~/pages/StatisticsPage/api/statistics.api';
import { StatisticsModel } from '~/pages/StatisticsPage/models/StatisticsModel';

export const statisticsQuery = queryOptions({
  queryKey: ['statistics'],
  queryFn: async () => {
    const data = await getStatistics();

    return new StatisticsModel(data);
  },
});
